'use client';

import React from 'react';

import cn from './style.module.sass';

type VideoSectionProps = {
    src: string;
    poster?: string;
};

export default function VideoSection({ src, poster }: VideoSectionProps) {
    return (
        <video
            poster={`${process.env.NEXT_PUBLIC_CONTENT_URL}${poster}`}
            width="320"
            height="240"
            controls={false}
            className={cn.video_section}
            muted={true}
            playsInline={true}
            autoPlay={true}
            loop={true}
        >
            <source src={`${process.env.NEXT_PUBLIC_CONTENT_URL}${src}`} type="video/mp4" />
            <source src={`${process.env.NEXT_PUBLIC_CONTENT_URL}${src}`} type="video/webm" />
        </video>
    );
}
